import { MSApp } from "../ms_front_lib/app/MSApp";
import { MSIcon } from "../ms_front_lib/components/MSIcon";
import { MSToast } from "../ms_front_lib/components/MSToast";
import { MSModal } from "../ms_front_lib/components/MSModal";

// load used forms
import { load as load_floating_labels_fields } from "../ms_front_lib/forms/FloatingLabelFields";
import { load as load_containers_fields } from "../ms_front_lib/forms/ContainerFields";
import { load as load_misc_fields } from "../ms_front_lib/forms/MiscFields";

// load app pages
import { Main } from "./pages/Main";
import { EMSBasket } from "./utils/ems/Basket";
import { EMSConfiserie } from "./utils/ems/Confiserie";
// import { Home } from "./pages/Home";
// import { PaneMovies } from "./pages/PaneMovies";
// import { PaneContact } from "./pages/PaneContact";
// import { PaneInfos } from "./pages/PaneInfos";
// import { PaneShortly } from "./pages/PaneShortly";
// import { PageLogin } from "./pages/PageLogin";
// import { PaneShowMovie } from "./pages/PaneShowMovie";
// import { PaneSchedule } from "./pages/PaneSchedule";
import { PageCustom } from "./pages/Custom";

const pack = require("../package.json");
import "./app.css";
import { Prog } from "./utils/Prog";
import { ToggleThemes } from "./utils/ThemeToggle";
import { data } from "jquery";
import moment from "moment";

export function is_on_mobile() {
  const to_match =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Windows Phone|Opera Mini|Mobile Safari|SymbianOS|Kindle|Silk|Mobile|Tablet/;
  return to_match.test(navigator.userAgent);
}

export function isIOS() {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
}

export class App extends MSApp {
  m_main_page;
  EMSBasket;
  PageIntervalRefresh;

  constructor() {
    super();

    this.commit = pack.commit;
    this.version = pack.version;
    this.stage = gl_config && gl_config.stage ? gl_config.stage : pack.unit.stage;
    this.is_secure_ip = pack.stage == "local";
    const mobileDetection = is_on_mobile();
    load_floating_labels_fields();
    load_containers_fields();
    load_misc_fields();
    this.website_active = gl_config.type == "site" && gl_config.site.website_active ? gl_config.site.website_active : gl_config.type == "site" ? false : true;

    MSIcon.init({
      user_settings:
        '<span class="material-symbols-outlined">manage_accounts</span>',
      logout: '<span class="material-symbols-outlined">logout</span>',
    });

    this.list_icons_svg = [
      {
        "id": "regular_user",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM96 128a128 128 0 1 1 256 0A128 128 0 1 1 96 128zM49.3 464l349.5 0c-8.9-63.3-63.3-112-129-112l-91.4 0c-65.7 0-120.1 48.7-129 112zM0 482.3C0 383.8 79.8 304 178.3 304l91.4 0C368.2 304 448 383.8 448 482.3c0 16.4-13.3 29.7-29.7 29.7L29.7 512C13.3 512 0 498.7 0 482.3z"/></svg>'
      },
      {
        "id": "regular_circle_user",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M406.5 399.6C387.4 352.9 341.5 320 288 320l-64 0c-53.5 0-99.4 32.9-118.5 79.6C69.9 362.2 48 311.7 48 256C48 141.1 141.1 48 256 48s208 93.1 208 208c0 55.7-21.9 106.2-57.5 143.6zm-40.1 32.7C334.4 452.4 296.6 464 256 464s-78.4-11.6-110.5-31.7c7.3-36.7 39.7-64.3 78.5-64.3l64 0c38.8 0 71.2 27.6 78.5 64.3zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-272a40 40 0 1 1 0-80 40 40 0 1 1 0 80zm-88-40a88 88 0 1 0 176 0 88 88 0 1 0 -176 0z"/></svg>'
      },
      {
        "id": "regular_pencil",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M36.4 360.9L13.4 439 1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1L73 498.6l78.1-23c10.4-3 20.1-8 28.6-14.5l.3 .2 .5-.8c1.4-1.1 2.7-2.2 4-3.3c1.4-1.2 2.7-2.5 4-3.8L492.7 149.3c21.9-21.9 24.6-55.6 8.2-80.5c-2.3-3.5-5.1-6.9-8.2-10L453.3 19.3c-25-25-65.5-25-90.5 0L58.6 323.5c-2.5 2.5-4.9 5.2-7.1 8l-.8 .5 .2 .3c-6.5 8.5-11.4 18.2-14.5 28.6zM383 191L197.4 376.6l-49.6-12.4-12.4-49.6L321 129 383 191zM97 358.9l7.7 31c2.1 8.6 8.9 15.3 17.5 17.5l31 7.7-7.4 11.2c-2.6 1.4-5.3 2.6-8.1 3.4l-23.4 6.9L59.4 452.6l16.1-54.8 6.9-23.4c.8-2.8 2-5.6 3.4-8.1L97 358.9zM315.3 218.7c6.2-6.2 6.2-16.4 0-22.6s-16.4-6.2-22.6 0l-96 96c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l96-96z"/></svg>'
      },
      {
        "id": "regular_ticket",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M64 64C28.7 64 0 92.7 0 128l0 60.1c0 10.2 6.4 19.2 16 22.6c18.7 6.6 32 24.4 32 45.3s-13.3 38.7-32 45.3c-9.6 3.4-16 12.5-16 22.6L0 384c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-60.1c0-10.2-6.4-19.2-16-22.6c-18.7-6.6-32-24.4-32-45.3s13.3-38.7 32-45.3c9.6-3.4 16-12.5 16-22.6l0-60.1c0-35.3-28.7-64-64-64L64 64zM48 128c0-8.8 7.2-16 16-16l448 0c8.8 0 16 7.2 16 16l0 44.9c-28.7 16.6-48 47.6-48 83.1s19.3 66.6 48 83.1l0 44.9c0 8.8-7.2 16-16 16L64 400c-8.8 0-16-7.2-16-16l0-44.9c28.7-16.6 48-47.6 48-83.1s-19.3-66.6-48-83.1L48 128zM400 304l-224 0 0-96 224 0 0 96zM128 192l0 128c0 17.7 14.3 32 32 32l256 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l-256 0c-17.7 0-32 14.3-32 32z"/></svg>'
      },
      {
        "id": "regular_glasses",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M118.6 80c-11.5 0-21.4 7.9-24 19.1L57.1 259.8c25.6-7.8 52.6-11.8 78.6-11.8c40.1 0 82.2 9.6 118.5 27.3c5.8 2.9 10.4 7.3 13.5 12.7l40.6 0c3.1-5.4 7.7-9.8 13.5-12.7c36.2-17.8 78.4-27.3 118.5-27.3c26 0 53 4.1 78.6 11.8L481.4 99.1c-2.6-11.2-12.6-19.1-24-19.1c-3.1 0-6.2 .6-9.2 1.8L416.9 94.3c-12.3 4.9-26.3-1.1-31.2-13.4s1.1-26.3 13.4-31.2l31.3-12.5c8.6-3.4 17.7-5.2 27-5.2c33.8 0 63.1 23.3 70.8 56.2l43.9 188c1.7 7.3 2.9 14.7 3.5 22.2c.3 1.8 .5 3.7 .5 5.6l0 5.2c0 .5 0 1 0 1.5l0 41.3c0 .2 0 .4 0 .6l0 15.4c0 61.9-50.1 112-112 112l-44.3 0c-59.4 0-108.5-46.4-111.8-105.8L306.6 352l-37.2 0-1.2 22.2C264.9 433.6 215.8 480 156.3 480L112 480C50.1 480 0 429.9 0 368l0-16 0-41.3L0 304c0-1.9 .2-3.8 .5-5.7c.6-7.4 1.8-14.8 3.5-22.1l43.9-188C55.5 55.3 84.8 32 118.6 32c9.2 0 18.4 1.8 27 5.2l31.3 12.5c12.3 4.9 18.3 18.9 13.4 31.2s-18.9 18.3-31.2 13.4L127.8 81.8c-2.9-1.2-6-1.8-9.2-1.8zM48 352l0 16c0 35.3 28.7 64 64 64l44.3 0c34 0 62-26.5 63.9-60.5l3.2-57.5c-27.3-11.7-58.3-18-87.7-18c-29.5 0-60.5 6.4-87.7 18.2L48 352zm392.3-56c-29.4 0-60.4 6.3-87.7 18l3.2 57.5c1.9 33.9 29.9 60.5 63.9 60.5l44.3 0c35.3 0 64-28.7 64-64l0-53.8c-27.2-11.8-58.2-18.2-87.7-18.2z"/></svg>'
      },
      {
        "id": "regular_rectangle_barcode",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm120 32c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm72 0c8.8 0 16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16zm48 24c0-13.3 10.7-24 24-24s24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208zm136-24c13.3 0 24 10.7 24 24l0 208c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-208c0-13.3 10.7-24 24-24zm72 16c0-8.8 7.2-16 16-16s16 7.2 16 16l0 224c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224z"/></svg>'
      },
      {
        "id": "regular_loveseat",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M176 80l160 0c44.2 0 80 35.8 80 80l0 34.8c7.7-1.8 15.7-2.8 24-2.8s16.3 1 24 2.8l0-34.8c0-70.7-57.3-128-128-128L176 32C105.3 32 48 89.3 48 160l0 34.8c7.7-1.8 15.7-2.8 24-2.8s16.3 1 24 2.8L96 160c0-44.2 35.8-80 80-80zM462.5 227.6c-7.1-2.3-14.6-3.6-22.5-3.6c-9.5 0-18.5 1.8-26.8 5.2c-24.1 9.7-41.8 32-44.7 58.8l-224.9 0c-3-26.8-20.6-49.1-44.7-58.8C90.5 225.8 81.5 224 72 224c-7.9 0-15.4 1.3-22.5 3.6C20.7 237 0 264.1 0 296L0 432c0 26.5 21.5 48 48 48l48 0c20.9 0 38.7-13.4 45.3-32l229.5 0c6.6 18.6 24.4 32 45.3 32l48 0c26.5 0 48-21.5 48-48l0-136c0-31.9-20.7-59-49.5-68.4zM368 400l-224 0 0-64 32 0 160 0 32 0 0 64zM96 400l0 32-48 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24l0 40 0 64zM464 296l0 136-48 0 0-136c0-13.3 10.7-24 24-24s24 10.7 24 24z"/></svg>'
      },
      {
        "id": "regular_circle_xmark",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM175 175c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"/></svg>'
      },
      {
        "id": "regular_circle_info",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0 0-88c0-13.3-10.7-24-24-24l-48 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l24 0 0 64-24 0zm40-144a32 32 0 1 0 0-64 32 32 0 1 0 0 64z"/></svg>'
      },
      {
        "id": "regular_badge_check",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5C317.1 91.7 329 96.6 340 93.2c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1c-3.4 11 1.5 22.9 11.7 28.2c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7c-10.2 5.4-15.1 17.2-11.7 28.2c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7c-11-3.4-22.9 1.5-28.2 11.7c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5c-5.4-10.2-17.2-15.1-28.2-11.7c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340c3.4-11-1.5-22.9-11.7-28.2C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7C91.7 194.9 96.6 183 93.2 172c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2c11 3.4 22.9-1.5 28.2-11.7zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zM369 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-111 111-47-47c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l64 64c9.4 9.4 24.6 9.4 33.9 0L369 209z"/></svg>'
      },
      {
        "id": "regular_chevron_down",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M239 401c9.4 9.4 24.6 9.4 33.9 0L465 209c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-175 175L81 175c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 401z"/></svg>'
      },
      {
        "id": "regular_chevron_up",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M239 111c9.4-9.4 24.6-9.4 33.9 0L465 303c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-175-175L81 337c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 111z"/></svg>'
      },
      {
        "id": "regular_chevron_left",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M15 239c-9.4 9.4-9.4 24.6 0 33.9L207 465c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9L65.9 256 241 81c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0L15 239z"/></svg>'
      },
      {
        "id": "regular_location_dot",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 12.4 4.5 31.6 15.3 57.2c10.5 24.8 25.4 52.2 42.5 79.9c28.5 46.2 61.5 90.8 86.2 122.6c24.8-31.8 57.8-76.4 86.2-122.6c17.1-27.7 32-55.1 42.5-79.9C331.5 223.6 336 204.4 336 192zm48 0c0 87.4-117 243-168.3 307.2c-12.3 15.3-35.1 15.3-47.4 0C117 435 0 279.4 0 192C0 86 86 0 192 0S384 86 384 192zm-160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z"/></svg>'
      },
      {
        "id": "regular_phone",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M375.8 275.2c-16.4-7-35.4-2.4-46.7 11.4l-33.2 40.6c-46-26.7-84.4-65.1-111.1-111.1L225.3 183c13.8-11.3 18.5-30.3 11.4-46.7l-48-112C181.2 6.7 162.3-3.1 143.6 .9l-112 24C13.2 28.8 0 45.1 0 64c0 0 0 0 0 0C0 295.2 175.2 485.6 400.1 509.5c9.8 1 19.6 1.8 29.6 2.2c0 0 0 0 0 0c0 0 .1 0 .1 0c6.1 .2 12.1 .4 18.2 .4c0 0 0 0 0 0c18.9 0 35.2-13.2 39.1-31.6l24-112c4-18.7-5.8-37.6-23.4-45.1l-112-48zM441.5 464C225.8 460.5 51.5 286.2 48.1 70.5l99.2-21.3 43 100.4L154.4 179c-18.2 14.9-22.9 40.8-11.1 61.2c30.9 53.3 75.3 97.7 128.6 128.6c20.4 11.8 46.3 7.1 61.2-11.1l29.4-35.9 100.4 43L441.5 464zM48 64s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0z"/></svg>'
      },
      {
        "id": "regular_envelope",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M64 112c-8.8 0-16 7.2-16 16l0 22.1L220.5 291.7c20.7 17 50.4 17 71.1 0L464 150.1l0-22.1c0-8.8-7.2-16-16-16L64 112zM48 212.2L48 384c0 8.8 7.2 16 16 16l384 0c8.8 0 16-7.2 16-16l0-171.8L322 328.8c-38.4 31.5-93.7 31.5-132 0L48 212.2zM0 128C0 92.7 28.7 64 64 64l384 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 448c-35.3 0-64-28.7-64-64L0 128z"/></svg>'
      },
      {
        "id": "regular_eye",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M288 80c-65.2 0-118.8 29.6-159.9 67.7C89.6 183.5 63 226 49.4 256c13.6 30 40.2 72.5 78.6 108.3C169.2 402.4 222.8 432 288 432s118.8-29.6 159.9-67.7C486.4 328.5 513 286 526.6 256c-13.6-30-40.2-72.5-78.6-108.3C406.8 109.6 353.2 80 288 80zM95.4 112.6C142.5 68.8 207.2 32 288 32s145.5 36.8 192.6 80.6c46.8 43.5 78.1 95.4 93 131.1c3.3 7.9 3.3 16.7 0 24.6c-14.9 35.7-46.2 87.7-93 131.1C433.5 443.2 368.8 480 288 480s-145.5-36.8-192.6-80.6C48.6 356 17.3 304 2.5 268.3c-3.3-7.9-3.3-16.7 0-24.6C17.3 208 48.6 156 95.4 112.6zM288 336c44.2 0 80-35.8 80-80s-35.8-80-80-80c-.7 0-1.3 0-2 0c1.3 5.1 2 10.5 2 16c0 35.3-28.7 64-64 64c-5.5 0-10.9-.7-16-2c0 .7 0 1.3 0 2c0 44.2 35.8 80 80 80zm0-208a128 128 0 1 1 0 256 128 128 0 1 1 0-256z"/></svg>'
      },
      {
        "id": "regular_lock",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M144 128l0 64 160 0 0-64c0-44.2-35.8-80-80-80s-80 35.8-80 80zM96 192l0-64C96 57.3 153.3 0 224 0s128 57.3 128 128l0 64 32 0c35.3 0 64 28.7 64 64l0 192c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 256c0-35.3 28.7-64 64-64l32 0zM48 256l0 192c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-192c0-8.8-7.2-16-16-16L64 240c-8.8 0-16 7.2-16 16z"/></svg>'
      },
      {
        "id": "regular_bag_shopping",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M160 112l0 48 128 0 0-48c0-35.3-28.7-64-64-64s-64 28.7-64 64zm-48 96l-64 0 0 208c0 26.5 21.5 48 48 48l256 0c26.5 0 48-21.5 48-48l0-208-64 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56-128 0 0 56c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-56zm0-48l0-48C112 50.1 162.1 0 224 0s112 50.1 112 112l0 48 64 0c26.5 0 48 21.5 48 48l0 208c0 53-43 96-96 96L96 512c-53 0-96-43-96-96L0 208c0-26.5 21.5-48 48-48l64 0z"/></svg>'
      },
      {
        "id": "regular_credit_card",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M512 80c8.8 0 16 7.2 16 16l0 32L48 128l0-32c0-8.8 7.2-16 16-16l448 0zm16 144l0 192c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16l0-192 480 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm56 304c-13.3 0-24 10.7-24 24s10.7 24 24 24l48 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-48 0zm128 0c-13.3 0-24 10.7-24 24s10.7 24 24 24l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-112 0z"/></svg>'
      },
      {
        "id": "regular_credit_card_front",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l448 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM96 360c0-13.3 10.7-24 24-24l48 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-48 0c-13.3 0-24-10.7-24-24zm128 0c0-13.3 10.7-24 24-24l112 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-112 0c-13.3 0-24-10.7-24-24zM96 280c0-13.3 10.7-24 24-24l336 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-336 0c-13.3 0-24-10.7-24-24zM376 128l80 0c13.3 0 24 10.7 24 24l0 48c0 13.3-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24l0-48c0-13.3 10.7-24 24-24z"/></svg>'
      },
      {
        "id": "regular_file_pdf",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z"/></svg>'
      },
      {
        "id": "regular_cash_register",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M64 0C46.3 0 32 14.3 32 32l0 64c0 17.7 14.3 32 32 32l80 0 0 32-56.5 0c-31.8 0-58.9 23.4-63.4 54.9L.6 379.5c-.4 3-.6 6-.6 9L0 448c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-59.5c0-3-.2-6.1-.6-9L487.8 214.9c-4.5-31.5-31.5-54.9-63.4-54.9L208 160l0-32 80 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32L64 0zM96 48l160 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L96 80c-8.8 0-16-7.2-16-16s7.2-16 16-16zM48 448l0-16 416 0 0 16c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16zM440.3 221.7L463.5 384l-415 0L71.7 221.7c1.1-7.9 7.9-13.7 15.8-13.7l337 0c8 0 14.7 5.9 15.8 13.7zM112 232a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm72 24a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48zm120-56a24 24 0 1 0 48 0 24 24 0 1 0 -48 0zm-24 56a24 24 0 1 0 0 48 24 24 0 1 0 0-48z"/></svg>'
      },
      {
        "id": "regular_square_check",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M64 80c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l320 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16L64 80zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM337 209L209 337c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l47 47L303 175c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9z"/></svg>'
      },
      {
        "id": "regular_download",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M280 24c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 270.1-95-95c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9L239 369c9.4 9.4 24.6 9.4 33.9 0L409 233c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-95 95L280 24zM128.8 304L64 304c-35.3 0-64 28.7-64 64l0 80c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-80c0-35.3-28.7-64-64-64l-64.8 0-48 48L448 352c8.8 0 16 7.2 16 16l0 80c0 8.8-7.2 16-16 16L64 464c-8.8 0-16-7.2-16-16l0-80c0-8.8 7.2-16 16-16l112.8 0-48-48zM432 408a24 24 0 1 0 -48 0 24 24 0 1 0 48 0z"/></svg>'
      },
      {
        "id": "regular_print",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M112 160l0-96c0-8.8 7.2-16 16-16l229.5 0c4.2 0 8.3 1.7 11.3 4.7l26.5 26.5c3 3 4.7 7.1 4.7 11.3l0 69.5 48 0 0-69.5c0-17-6.7-33.3-18.7-45.3L402.7 18.7C390.7 6.7 374.5 0 357.5 0L128 0C92.7 0 64 28.7 64 64l0 96 48 0zm16 208l256 0 0 96-256 0 0-96zm-16-48c-17.7 0-32 14.3-32 32l-32 0 0-96c0-8.8 7.2-16 16-16l384 0c8.8 0 16 7.2 16 16l0 96-32 0c0-17.7-14.3-32-32-32l-288 0zm320 80l48 0c17.7 0 32-14.3 32-32l0-112c0-35.3-28.7-64-64-64L64 192c-35.3 0-64 28.7-64 64L0 368c0 17.7 14.3 32 32 32l48 0 0 80c0 17.7 14.3 32 32 32l288 0c17.7 0 32-14.3 32-32l0-80z"/></svg>'
      },
      {
        "id": "regular_pen_to_square",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M441 58.9L453.1 71c9.4 9.4 9.4 24.6 0 33.9L424 134.1 377.9 88 407 58.9c9.4-9.4 24.6-9.4 33.9 0zM209.8 256.2L344 121.9 390.1 168 255.8 302.2c-2.9 2.9-6.5 5-10.4 6.1l-58.5 16.7 16.7-58.5c1.1-3.9 3.2-7.5 6.1-10.4zM373.1 25L175.8 222.2c-8.7 8.7-15 19.4-18.3 31.1l-28.6 100c-2.4 8.4-.1 17.4 6.1 23.6s15.2 8.5 23.6 6.1l100-28.6c11.8-3.4 22.5-9.7 31.1-18.3L487 138.9c28.1-28.1 28.1-73.7 0-101.8L474.9 25C446.8-3.1 401.2-3.1 373.1 25zM88 64C39.4 64 0 103.4 0 152L0 424c0 48.6 39.4 88 88 88l272 0c48.6 0 88-39.4 88-88l0-112c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 112c0 22.1-17.9 40-40 40L88 464c-22.1 0-40-17.9-40-40l0-272c0-22.1 17.9-40 40-40l112 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L88 64z"/></svg>'
      },
      {
        "id": "regular_message",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M160 368c26.5 0 48 21.5 48 48l0 16 72.5-54.4c8.3-6.2 18.4-9.6 28.8-9.6L448 368c8.8 0 16-7.2 16-16l0-288c0-8.8-7.2-16-16-16L64 48c-8.8 0-16 7.2-16 16l0 288c0 8.8 7.2 16 16 16l96 0zm48 124l-.2 .2-5.1 3.8-17.1 12.8c-4.8 3.6-11.3 4.2-16.8 1.5s-8.8-8.2-8.8-14.3l0-21.3 0-6.4 0-.3 0-4 0-48-48 0-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L448 0c35.3 0 64 28.7 64 64l0 288c0 35.3-28.7 64-64 64l-138.7 0L208 492z"/></svg>'
      },
      {
        "id": "regular_ban",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M385.1 419.1L92.9 126.9C64.8 162.3 48 207.2 48 256c0 114.9 93.1 208 208 208c48.8 0 93.7-16.8 129.1-44.9zm33.9-33.9C447.2 349.7 464 304.8 464 256c0-114.9-93.1-208-208-208c-48.8 0-93.7 16.8-129.1 44.9L419.1 385.1zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z"/></svg>'
      },
      {
        "id": "regular_repeat",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M22.8 280C9.6 279.3-.6 268 0 254.8l.4-8C5.3 148.9 86.2 72 184.2 72L304 72l0-36.4C304 15.9 319.9 0 339.6 0c8.8 0 17.3 3.3 23.8 9.1l76.7 69c5.1 4.6 7.9 11 7.9 17.8s-2.9 13.3-7.9 17.8l-76.7 69c-6.5 5.9-15 9.1-23.8 9.1c-19.6 0-35.6-15.9-35.6-35.6l0-36.4-119.8 0C111.7 120 52 176.8 48.4 249.2l-.4 8C47.3 270.4 36 280.6 22.8 280zM352 128.5L388.1 96 352 63.5l0 65zM489.2 232c13.2 .7 23.4 11.9 22.8 25.2l-.4 8C506.7 363.1 425.8 440 327.8 440L208 440l0 36.4c0 19.6-15.9 35.6-35.6 35.6c-8.8 0-17.3-3.3-23.8-9.1l-76.7-69c-5.1-4.6-7.9-11-7.9-17.8s2.9-13.3 7.9-17.8l76.7-69c6.5-5.9 15-9.1 23.8-9.1c19.6 0 35.6 15.9 35.6 35.6l0 36.4 119.8 0c72.5 0 132.2-56.8 135.8-129.2l.4-8c.7-13.2 11.9-23.4 25.2-22.8zM160 383.5L123.9 416 160 448.5l0-65z"/></svg>'
      },
      {
        "id": "regular_arrow_up_right",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M328 96c13.3 0 24 10.7 24 24l0 240c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-182.1L73 409c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l231-231L88 144c-13.3 0-24-10.7-24-24s10.7-24 24-24l240 0z"/></svg>'
      },
      {
        "id": "regular_arrow_right",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z"/></svg>'
      },
      {
        "id": "regular_layer_group",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M288 0c-8.5 0-17 1.7-24.8 5.1L53.9 94.8C40.6 100.5 32 113.5 32 128s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2L312.8 5.1C305 1.7 296.5 0 288 0zm-5.9 49.2C284 48.4 286 48 288 48s4 .4 5.9 1.2L477.7 128 293.9 206.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 128 282.1 49.2zM53.9 222.8C40.6 228.5 32 241.5 32 256s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 235.5 477.7 256 293.9 334.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 256 146 235.5 85.1 209.4 53.9 222.8zm0 128C40.6 356.5 32 369.5 32 384s8.6 27.5 21.9 33.2l209.3 89.7c7.8 3.4 16.3 5.1 24.8 5.1s17-1.7 24.8-5.1l209.3-89.7c13.3-5.7 21.9-18.8 21.9-33.2s-8.6-27.5-21.9-33.2l-31.2-13.4L430 363.5 477.7 384 293.9 462.8c-1.9 .8-3.9 1.2-5.9 1.2s-4-.4-5.9-1.2L98.3 384 146 363.5 85.1 337.4 53.9 350.8z"/></svg>'
      },
      {
        "id": "regular_money_from_bracket",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M48 88l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24L0 88C0 39.4 39.4 0 88 0L552 0c48.6 0 88 39.4 88 88l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-22.1-17.9-40-40-40L88 48C65.9 48 48 65.9 48 88zm416 8l48 0 0 352c0 35.3-28.7 64-64 64l-256 0c-35.3 0-64-28.7-64-64l0-352 48 0 0 304c35.3 0 64 28.7 64 64l160 0c0-35.3 28.7-64 64-64l0-304zM320 352c-53 0-96-35.8-96-80s43-80 96-80s96 35.8 96 80s-43 80-96 80z"/></svg>'
      },
      {
        "id": "regular_gift",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M231.9 44.4C215.7 16.9 186.1 0 154.2 0L152 0C103.4 0 64 39.4 64 88c0 14.4 3.5 28 9.6 40L48 128c-26.5 0-48 21.5-48 48l0 64c0 20.9 13.4 38.7 32 45.3l0 2.7 0 160c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-160 0-2.7c18.6-6.6 32-24.4 32-45.3l0-64c0-26.5-21.5-48-48-48l-25.6 0c6.1-12 9.6-25.6 9.6-40c0-48.6-39.4-88-88-88l-2.2 0c-31.9 0-61.5 16.9-77.7 44.4L256 85.5l-24.1-41zM464 176l0 64-32 0-144 0 0-64 72 0 104 0zm-240 0l0 64L80 240l-32 0 0-64 104 0 72 0zm0 112l0 176L96 464c-8.8 0-16-7.2-16-16l0-160 144 0zm64 176l0-176 144 0 0 160c0 8.8-7.2 16-16 16l-128 0zm72-336l-72 0-1.3 0 34.8-59.2C329.1 55.9 342.9 48 357.8 48l2.2 0c22.1 0 40 17.9 40 40s-17.9 40-40 40zm-136 0l-72 0c-22.1 0-40-17.9-40-40s17.9-40 40-40l2.2 0c14.9 0 28.8 7.9 36.3 20.8L225.3 128l-1.3 0z"/></svg>'
      },
      {
        "id": "regular_gift_card",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M353.5 68.8L318.7 128l1.3 0 72 0c22.1 0 40-17.9 40-40s-17.9-40-40-40l-2.2 0c-14.9 0-28.8 7.9-36.3 20.8zM288 197.5l-61.6 73.9c-8.5 10.2-23.6 11.6-33.8 3.1s-11.6-23.6-3.1-33.8L243.4 176 184 176 64 176c-8.8 0-16 7.2-16 16l0 128 480 0 0-128c0-8.8-7.2-16-16-16l-120 0-59.4 0 53.9 64.6c8.5 10.2 7.1 25.3-3.1 33.8s-25.3 7.1-33.8-3.1L288 197.5zM48 384l0 64c0 8.8 7.2 16 16 16l448 0c8.8 0 16-7.2 16-16l0-64L48 384zM256 128l1.3 0L222.5 68.8C214.9 55.9 201.1 48 186.2 48L184 48c-22.1 0-40 17.9-40 40s17.9 40 40 40l72 0zm7.9-83.6l24.1 41 24.1-41C328.3 16.9 357.9 0 389.8 0L392 0c48.6 0 88 39.4 88 88c0 14.4-3.5 28-9.6 40l41.6 0c35.3 0 64 28.7 64 64l0 256c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 192c0-35.3 28.7-64 64-64l41.6 0C99.5 116 96 102.4 96 88c0-48.6 39.4-88 88-88l2.2 0c31.9 0 61.5 16.9 77.7 44.4z"/></svg>'
      },
      {
        "id": "regular_user_secret",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M224 16c-6.7 0-10.8-2.8-15.5-6.1C201.9 5.4 194 0 176 0c-30.5 0-52 43.7-66 89.4C62.7 98.1 32 112.2 32 128c0 13.4 22.1 25.6 57.7 34.3C88.6 169.4 88 176.6 88 184c0 13.9 2.1 27.4 6 40l-48.6 0C38 224 32 230 32 237.4c0 1.7 .3 3.4 1 5l38.8 96.9C28.2 371.8 0 423.8 0 482.3C0 498.7 13.3 512 29.7 512L168 512l112 0 138.3 0c16.4 0 29.7-13.3 29.7-29.7c0-58.5-28.2-110.4-71.7-143L415 242.4c.6-1.6 1-3.3 1-5c0-7.4-6-13.4-13.4-13.4L354 224c3.9-12.6 6-26.1 6-40c0-7.4-.6-14.6-1.7-21.7c35.6-8.7 57.7-20.9 57.7-34.3c0-15.8-30.7-29.9-78-38.6C324 43.7 302.5 0 272 0c-18 0-25.9 5.4-32.5 9.9c-4.8 3.3-8.8 6.1-15.5 6.1zm44 448l-24.8-99.1c-2.1-8.2-.8-16.9 3.6-24.2l15.7-26.2c25.7-7.6 48.3-22.6 65.2-42.5l23.8 0-19.8 49.5c-8.1 20.2-1.6 43.3 15.9 56.3c27.3 20.4 46.2 51 51.2 86.2L268 464zM185.5 314.5l15.7 26.2c4.4 7.3 5.7 16 3.6 24.2L180 464 49.3 464c4.9-35.2 23.9-65.8 51.2-86.2c17.4-13 23.9-36.1 15.9-56.3L96.5 272l23.8 0c16.9 19.9 39.5 34.9 65.2 42.5zM224 272c-38.2 0-70.7-24.4-82.9-58.4c7.1 6.5 16.5 10.4 26.9 10.4l12.4 0c16.5 0 31.1-10.6 36.3-26.2c2.3-7 12.2-7 14.5 0c5.2 15.6 19.9 26.2 36.3 26.2l12.4 0c10.4 0 19.8-3.9 26.9-10.4c-12.2 34-44.7 58.4-82.9 58.4z"/></svg>'
      },
      {
        "id": "regular_address_card",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M512 80c8.8 0 16 7.2 16 16l0 320c0 8.8-7.2 16-16 16L64 432c-8.8 0-16-7.2-16-16L48 96c0-8.8 7.2-16 16-16l448 0zM64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM208 256a64 64 0 1 0 0-128 64 64 0 1 0 0 128zm-32 32c-44.2 0-80 35.8-80 80c0 8.8 7.2 16 16 16l192 0c8.8 0 16-7.2 16-16c0-44.2-35.8-80-80-80l-64 0zM376 144c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0zm0 96c-13.3 0-24 10.7-24 24s10.7 24 24 24l80 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-80 0z"/></svg>'
      },
      {
        "id": "regular_circle_play",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM188.3 147.1c7.6-4.2 16.8-4.1 24.3 .5l144 88c7.1 4.4 11.5 12.1 11.5 20.5s-4.4 16.1-11.5 20.5l-144 88c-7.4 4.5-16.7 4.7-24.3 .5s-12.3-12.2-12.3-20.9l0-176c0-8.7 4.7-16.7 12.3-20.9z"/></svg>'
      },
      {
        "id": "regular_popcorn",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M32 156c0-20.9 14.5-38.3 34-42.9c-1.3-4.2-2-8.6-2-13.1c0-24.3 19.7-44 44-44c1.9 0 3.7 .1 5.6 .3C118.7 37.7 135.7 24 156 24c8.5 0 16.5 2.4 23.2 6.6C186.2 12.7 203.6 0 224 0s37.8 12.7 44.8 30.6c6.7-4.2 14.7-6.6 23.2-6.6c20.3 0 37.3 13.7 42.4 32.3c1.8-.2 3.7-.3 5.6-.3c24.3 0 44 19.7 44 44c0 4.6-.7 9-2 13.1c19.5 4.5 34 22 34 42.9c0 1.3-.1 2.7-.2 4l-87.6 0-208.4 0-87.6 0c-.1-1.3-.2-2.7-.2-4zm22.3 84l62.2 224 215 0 62.2-224-47 0L303.6 419.7c-2.1 8.6-10.7 13.9-19.3 11.8s-13.9-10.7-11.8-19.3L313.8 240 240 240l0 176c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-176-73.8 0 41.3 172.3c2.1 8.6-3.2 17.2-11.8 19.3s-17.2-3.2-19.3-11.8L101.3 240l-47 0zM224 192l195.8 0c15.6 0 28.2 12.6 28.2 28.2c0 2.5-.3 5.1-1 7.5L377.8 476.8C372 497.6 353.1 512 331.5 512l-215 0c-21.6 0-40.5-14.4-46.2-35.2L1 227.7c-.7-2.5-1-5-1-7.5C0 204.6 12.6 192 28.2 192L224 192z"/></svg>'
      },
      {
        "id": "light_popcorn",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M178.9 22.9c-8-4.4-17.1-6.9-26.9-6.9c-25.5 0-47 17-53.8 40.3C70 59.2 48 83 48 112c0 4.4 .5 8.6 1.5 12.7C34.5 131.3 23 144.2 18.3 160l35.8 0c4.4-4.9 10.8-8 17.9-8c6.1 0 11.6-3.4 14.3-8.9s2.1-11.9-1.5-16.8c-3-4-4.8-9-4.8-14.4c0-13.3 10.7-24 24-24c1.7 0 3.3 .2 4.8 .5c4.7 1 9.6-.3 13.4-3.3s5.9-7.7 5.8-12.5l0-.7C128 58.7 138.8 48 152 48c8.1 0 15.2 4 19.6 10.1c3.7 5.3 10.2 7.8 16.5 6.4s11.1-6.4 12.3-12.8C202.4 40.5 212.2 32 224 32s21.6 8.5 23.6 19.7c1.1 6.3 6 11.4 12.3 12.8s12.8-1.1 16.5-6.4C280.8 52 287.9 48 296 48c13.2 0 24 10.7 24 23.9l0 .7c0 4.8 2.1 9.4 5.8 12.5s8.6 4.3 13.4 3.3c1.5-.3 3.2-.5 4.8-.5c13.3 0 24 10.7 24 24c0 3.5-.7 6.8-2.1 9.7c-2.1 4.7-1.8 10 .7 14.5s7 7.4 12.1 8c9.2 1 16.9 7.4 19.9 15.8l32.8 0c-2.7-19-14.9-34.9-31.7-42.7c.2-1.7 .2-3.5 .2-5.3c0-29-22-52.8-50.2-55.7C343 33 321.5 16 296 16c-9.7 0-18.9 2.5-26.9 6.9C258.9 9 242.5 0 224 0s-34.9 9-45.1 22.9zM33.2 224l64.9 0 30 210.3c1.2 8.7 9.4 14.8 18.1 13.6s14.8-9.4 13.6-18.1L130.4 224l77.6 0 0 208c0 8.8 7.2 16 16 16s16-7.2 16-16l0-208 77.6 0L288.2 429.7c-1.2 8.7 4.8 16.9 13.6 18.1s16.9-4.8 18.1-13.6l30-210.3 64.9 0L346.9 468.3c-1.9 6.9-8.2 11.7-15.4 11.7l-215 0c-7.2 0-13.5-4.8-15.4-11.7L33.2 224zM224 192l-111.7 0-.5 0-83.6 0C12.6 192 0 204.6 0 220.2c0 2.5 .3 5.1 1 7.5L70.2 476.8C76 497.6 94.9 512 116.5 512l215 0c21.6 0 40.5-14.4 46.2-35.2L447 227.7c.7-2.5 1-5 1-7.5c0-15.6-12.6-28.2-28.2-28.2l-83.6 0-.5 0L224 192z"/></svg>'
      },
      {
        "id": "regular_plus",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M248 72c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 160L40 232c-13.3 0-24 10.7-24 24s10.7 24 24 24l160 0 0 160c0 13.3 10.7 24 24 24s24-10.7 24-24l0-160 160 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-160 0 0-160z"/></svg>'
      },
      {
        "id": "regular_minus",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M432 256c0 13.3-10.7 24-24 24L40 280c-13.3 0-24-10.7-24-24s10.7-24 24-24l368 0c13.3 0 24 10.7 24 24z"/></svg>'
      },
      {
        "id": "regular_user_xmark",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M144 128a80 80 0 1 1 160 0 80 80 0 1 1 -160 0zm208 0A128 128 0 1 0 96 128a128 128 0 1 0 256 0zM269.7 352c65.7 0 120.1 48.7 129 112L49.3 464c8.9-63.3 63.3-112 129-112l91.4 0zm-91.4-48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304L224 304l-45.7 0zM455 143c-9.4 9.4-9.4 24.6 0 33.9l47 47-47 47c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l47-47 47 47c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-47-47 47-47c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-47 47-47-47c-9.4-9.4-24.6-9.4-33.9 0z"/></svg>'
      },
      {
        "id": "regular_share_from_square",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M400 255.4l0-15.4 0-32c0-8.8-7.2-16-16-16l-32 0-16 0-46.5 0c-50.9 0-93.9 33.5-108.3 79.6c-3.3-9.4-5.2-19.8-5.2-31.6c0-61.9 50.1-112 112-112l48 0 16 0 32 0c8.8 0 16-7.2 16-16l0-32 0-15.4L506 160 400 255.4zM336 240l16 0 0 48c0 17.7 14.3 32 32 32l3.7 0c7.9 0 15.5-2.9 21.4-8.2l139-125.1c7.6-6.8 11.9-16.5 11.9-26.7s-4.3-19.9-11.9-26.7L409.9 8.9C403.5 3.2 395.3 0 386.7 0C367.5 0 352 15.5 352 34.7L352 80l-16 0-32 0-16 0c-88.4 0-160 71.6-160 160c0 60.4 34.6 99.1 63.9 120.9c5.9 4.4 11.5 8.1 16.7 11.2c4.4 2.7 8.5 4.9 11.9 6.6c3.4 1.7 6.2 3 8.2 3.9c2.2 1 4.6 1.4 7.1 1.4l2.5 0c9.8 0 17.8-8 17.8-17.8c0-7.8-5.3-14.7-11.6-19.5c0 0 0 0 0 0c-.4-.3-.7-.5-1.1-.8c-1.7-1.1-3.4-2.5-5-4.1c-.8-.8-1.7-1.6-2.5-2.6s-1.6-1.9-2.4-2.9c-1.8-2.5-3.5-5.3-5-8.5c-2.6-6-4.3-13.3-4.3-22.4c0-36.1 29.3-65.5 65.5-65.5l14.5 0 32 0zM72 32C32.2 32 0 64.2 0 104L0 440c0 39.8 32.2 72 72 72l336 0c39.8 0 72-32.2 72-72l0-64c0-13.3-10.7-24-24-24s-24 10.7-24 24l0 64c0 13.3-10.7 24-24 24L72 464c-13.3 0-24-10.7-24-24l0-336c0-13.3 10.7-24 24-24l64 0c13.3 0 24-10.7 24-24s-10.7-24-24-24L72 32z"/></svg>'
      },
      {
        "id": "regular_share_nodes",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M448 128c0 53-43 96-96 96c-28.9 0-54.8-12.8-72.4-33l-89.7 44.9c1.4 6.5 2.1 13.2 2.1 20.1s-.7 13.6-2.1 20.1L279.6 321c17.6-20.2 43.5-33 72.4-33c53 0 96 43 96 96s-43 96-96 96s-96-43-96-96c0-6.9 .7-13.6 2.1-20.1L168.4 319c-17.6 20.2-43.5 33-72.4 33c-53 0-96-43-96-96s43-96 96-96c28.9 0 54.8 12.8 72.4 33l89.7-44.9c-1.4-6.5-2.1-13.2-2.1-20.1c0-53 43-96 96-96s96 43 96 96zM96 304a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM400 128a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM352 432a48 48 0 1 0 0-96 48 48 0 1 0 0 96z"/></svg>'
      },
      {
        "id": "regular_clock",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM232 120l0 136c0 8 4 15.5 10.7 20l96 64c11 7.4 25.9 4.4 33.3-6.7s4.4-25.9-6.7-33.3L280 243.2 280 120c0-13.3-10.7-24-24-24s-24 10.7-24 24z"/></svg>'
      },
      {
        "id": "regular_basket_shopping",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M243.1 2.7c11.8 6.1 16.3 20.6 10.2 32.4L171.7 192l232.6 0L322.7 35.1c-6.1-11.8-1.5-26.3 10.2-32.4s26.2-1.5 32.4 10.2L458.4 192l36.1 0 49.5 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-20 0L476.1 463.5C469 492 443.4 512 414 512L162 512c-29.4 0-55-20-62.1-48.5L44 240l-20 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l8 0 49.5 0 36.1 0L210.7 12.9c6.1-11.8 20.6-16.3 32.4-10.2zM93.5 240l53 211.9c1.8 7.1 8.2 12.1 15.5 12.1L414 464c7.3 0 13.7-5 15.5-12.1l53-211.9-389 0zM224 312l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24zm64-24c13.3 0 24 10.7 24 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24zm112 24l0 80c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-80c0-13.3 10.7-24 24-24s24 10.7 24 24z"/></svg>'
      },
      {
        "id": "regular_house_blank",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M303.5 5.7c-9-7.6-22.1-7.6-31.1 0l-264 224c-10.1 8.6-11.3 23.7-2.8 33.8s23.7 11.3 33.8 2.8L64 245.5 64 432c0 44.2 35.8 80 80 80l288 0c44.2 0 80-35.8 80-80l0-186.5 24.5 20.8c10.1 8.6 25.3 7.3 33.8-2.8s7.3-25.3-2.8-33.8l-264-224zM464 204.8L464 432c0 17.7-14.3 32-32 32l-288 0c-17.7 0-32-14.3-32-32l0-227.2L288 55.5 464 204.8z"/></svg>'
      },
      {
        "id": "regular_heart",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 41.9-17.4 81.9-48.1 110.4L288.7 465.9l-2.5 2.3c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM239.1 145c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7 431.2 268c20.9-19.4 32.8-46.7 32.8-75.2l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7z"/></svg>'
      },
      {
        "id": "solid_heart",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M47.6 300.4L228.3 469.1c7.5 7 17.4 10.9 27.7 10.9s20.2-3.9 27.7-10.9L464.4 300.4c30.4-28.3 47.6-68 47.6-109.5v-5.8c0-69.9-50.5-129.5-119.4-141C347 36.5 300.6 51.4 268 84L256 96 244 84c-32.6-32.6-79-47.5-124.6-39.9C50.5 55.6 0 115.2 0 185.1v5.8c0 41.5 17.2 81.2 47.6 109.5z"/></svg>'
      },
      {
        "id": "regular_star",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z"/></svg>'
      },
      {
        "id": "solid_star",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg>'
      },
      {
        "id": "solid_star_half_stroke",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.--><path d="M309.5 13.5C305.5 5.2 297.1 0 287.9 0s-17.6 5.2-21.6 13.5L197.7 154.8 44.5 177.5c-9 1.3-16.5 7.6-19.3 16.3s-.5 18.1 5.9 24.5L142.2 328.4 116 483.9c-1.5 9 2.2 18.1 9.7 23.5s17.3 6 25.3 1.7l137-73.2 137 73.2c8.1 4.3 17.9 3.7 25.3-1.7s11.2-14.5 9.7-23.5L433.6 328.4 544.8 218.2c6.5-6.4 8.7-15.9 5.9-24.5s-10.3-14.9-19.3-16.3L378.1 154.8 309.5 13.5zM288 384.7l0-305.6 52.5 108.1c3.5 7.1 10.2 12.1 18.1 13.3l118.3 17.5L391 303c-5.5 5.5-8.1 13.3-6.8 21l20.2 119.6L299.2 387.5c-3.5-1.9-7.4-2.8-11.2-2.8z"/></svg>'
      },
      {
        "id": "regular_heart_minus",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M225.8 468.2l-2.5-2.3L48.1 303.2C17.4 274.7 0 234.7 0 192.8l0-3.3c0-70.4 50-130.8 119.2-144C158.6 37.9 198.9 47 231 69.6c9 6.4 17.4 13.8 25 22.3c4.2-4.8 8.7-9.2 13.5-13.3c3.7-3.2 7.5-6.2 11.5-9c0 0 0 0 0 0C313.1 47 353.4 37.9 392.8 45.4C462 58.6 512 119.1 512 189.5l0 3.3c0 6-.4 12-1.1 17.9c-14.6-7.3-30.4-12.7-47-15.8c0-.7 0-1.4 0-2.1l0-3.3c0-47.3-33.6-88-80.1-96.9c-34-6.5-69 5.4-92 31.2c0 0 0 0-.1 .1s0 0-.1 .1l-17.8 20c-.3 .4-.7 .7-1 1.1c-4.5 4.5-10.6 7-16.9 7s-12.4-2.5-16.9-7c-.4-.3-.7-.7-1-1.1l-17.8-20-.1-.1s0 0 0 0c-23.1-25.9-58-37.7-92-31.2C81.6 101.5 48 142.1 48 189.5l0 3.3c0 28.5 11.9 55.8 32.8 75.2L256 430.7l8.7-8c5.3 16.1 12.8 31.2 22.2 44.9l-.6 .6c-8.2 7.6-19 11.9-30.2 11.9s-22-4.2-30.2-11.9zM288 368a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm224 0c0-8.8-7.2-16-16-16l-128 0c-8.8 0-16 7.2-16 16s7.2 16 16 16l128 0c8.8 0 16-7.2 16-16z"/></svg>'
      },
      {
        "id": "regular_trash",
        "svg_text": '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><!--!Font Awesome Pro 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license (Commercial License) Copyright 2025 Fonticons, Inc.--><path d="M177.1 48l93.7 0c2.7 0 5.2 1.3 6.7 3.6l19 28.4-145 0 19-28.4c1.5-2.2 4-3.6 6.7-3.6zM354.2 80L317.5 24.9C307.1 9.4 289.6 0 270.9 0L177.1 0c-18.7 0-36.2 9.4-46.6 24.9L93.8 80 80.1 80 32 80l-8 0C10.7 80 0 90.7 0 104s10.7 24 24 24l11.6 0L59.6 452.7c2.5 33.4 30.3 59.3 63.8 59.3l201.1 0c33.5 0 61.3-25.9 63.8-59.3L412.4 128l11.6 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-8 0-48.1 0-13.7 0zm10.1 48L340.5 449.2c-.6 8.4-7.6 14.8-16 14.8l-201.1 0c-8.4 0-15.3-6.5-16-14.8L83.7 128l280.6 0z"/></svg>'
      }
    ];
  }

  /*
    Initialisation
   */

  async start() {
    if (!gl_ems_config) {
      gl_ems_config = null;
    }

    if (this.stage == 'local') {
      console.log("gl_config", gl_config)
      console.log("gl_ems_config", gl_ems_config)
      console.log("Type website :", gl_config.type)
    }

    // Create main page
    this.m_main_page = new Main();

    if ($(".container-fluid.ssr").length > 0) {
      console.log("remove ssr")
      $(".container-fluid.ssr").remove();
    }

    // this.initThemeToggle();   

    // On veut récupérer les valeurs de "css_vars"
    // init_css_vars() // config.js

    // pour les tests on remplace les valeurs de css_vars
    // if (this.stage == 'local') {
    //   try {
    //     const local_theme = await import("./local_theme.json");
    //     const root_style = document.querySelector(":root").style;
    //     for (let key in local_theme.css_vars) {
    //       // console.log(`key: ${key}, value: ${local_theme.css_vars[key]}`);
    //       root_style.setProperty('--'+key, local_theme.css_vars[key]);
    //     }
    //   } catch (e) {
    //     console.error("local_theme.json not found");
    //   }
    // }

    // if (gl_config.website && gl_config.website.style && gl_config.website.style.css_vars) {
    //   const root_style = document.querySelector(":root").style;
    //   for (let key in gl_config.website.style.css_vars) {
    //     root_style.setProperty('--' + key, gl_config.website.style.css_vars[key]);
    //   }
    // } else if (gl_config.theme && gl_config.theme.css_vars) {
    //   const root_style = document.querySelector(":root").style;
    //   for (let key in gl_config.theme.css_vars) {
    //     root_style.setProperty('--' + key, gl_config.theme.css_vars[key]);
    //   }
    // }

    if (gl_config.theme && gl_config.theme.css_vars) {
      const root_style = document.querySelector(":root").style;
      for (let key in gl_config.theme.css_vars) {
        root_style.setProperty('--' + key, gl_config.theme.css_vars[key]);
      }
    }

    // Init de la font Dynamiquement, on récupère l'url de la Font dans la config.
    // const fontPath = (gl_config.theme && gl_config.theme.font_path) ? gl_config.theme.font_path : "https://static.monnaie-services.com/font/Mansfield-Light-iF66c703e4baba9.ttf";
    const fontPath = (gl_config.website && gl_config.website.style && gl_config.website.style.font) ? "https://static.monnaie-services.com/font/" + gl_config.website.style.font : "https://static.monnaie-services.com/font/Mansfield-Light.ttf";
    const styleSheet = document.styleSheets[0];
    styleSheet.insertRule(`
      @font-face {
        font-family: 'DynamicFont';
        src: url('${fontPath}') format('woff2');
      }
    `, styleSheet.cssRules.length);

    // Apply the font dynamically
    // document.body.style.fontFamily = 'DynamicFont, sans-serif';
    $("body").css({
      "font-family": "DynamicFont, sans-serif"
    })

    // Register hashes en fonction de si on est sur un portail groupe ou un site cinéma
    await import(`./pages/Login`);
    this.registerPane(gClsLoginPage, "login", this.m_main_page);

    const pages = await fetch("https://ws.imscine.com/website/pages.json", { cache: "reload" });
    this.default_pages = await pages.json();

    if (gl_config.type == "site") {
      this.EMSBasket = new EMSBasket();
      this.EMSConfiserie = new EMSConfiserie();

      // await import(`./pages/${gl_config.custom_pages.home ?? 'HomeDefault'}`);
      // this.registerPane(gClsHomePage, "home", this.m_main_page);

      // Définition de la page d'acceuil
      // Si cinéma imsWeb
      var homepage = null;
      if(gl_config.site && gl_config.site.website_active){
        homepage = async () => {
          await import(`./pages/${gl_config.custom_pages.home ?? 'HomeDefault'}`);
          return gClsHomePage;
        };
      }else{
        homepage = async () => {
          await import(`./pages/HomeLight`);
          return gClsHomePage;
        };
      }
      // this.registerPane(homepage, "", this.m_main_page);
      this.registerPane(homepage, "home", this.m_main_page);

      await import(`./pages/${gl_config.custom_pages.schedule ?? 'ScheduleDefault'}`);
      this.registerPane(gClsSchedulePage, "schedule", this.m_main_page);

      await import(`./pages/${gl_config.custom_pages.showmovie ?? 'ShowMovieDefault'}`);
      this.registerPane(gClsShowMoviePage, "showmovie", this.m_main_page);

      gl_config.software ??= "ems"; // Logiciel de fonctionnement => "ems" ou "ims"

      await import(`./pages/${gl_config.software}/ShowSessionDefault`);
      this.registerPane(gClsShowSession, "showsession", this.m_main_page);

      await import(`./pages/${gl_config.software}/ShowConfiserieDefault`);
      this.registerPane(gClsShowConfiserie, "showconfiserie", this.m_main_page);

      await import(`./pages/${gl_config.software}/ShowSuperbilletDefault`);
      this.registerPane(gClsShowSuperbillet, "showsuperbillet", this.m_main_page);

      await import(`./pages/${gl_config.software}/SubscriptionDefault`);
      this.registerPane(gClsSubscription, "subscription", this.m_main_page);

      await import(`./pages/${gl_config.software}/Cart`);
      this.registerPane(gClsCart, "cart", this.m_main_page);

      await import(`./pages/${gl_config.software}/Payment`);
      this.registerPane(gClsPayement, "payment", this.m_main_page);

      await import(`./pages/${gl_config.software}/EndOfOrder`);
      this.registerPane(gClsEndOfOrder, "end_of_order", this.m_main_page);

      await import(`./pages/${gl_config.software}/Account`);
      this.registerPane(gClsAccount, "account", this.m_main_page);

      await import(`./pages/${gl_config.software}/Refund`);
      this.registerPane(gClsRefund, "refund", this.m_main_page);

      await import(`./pages/${gl_config.software}/Fidelity`);
      this.registerPane(gClsPageFidelity, "fidelity", this.m_main_page);

      await import(`./pages/Cgv`);
      this.registerPane(gClsPageCgv, "cgv", this.m_main_page);

      await import(`./pages/Contact`);
      this.registerPane(gClsPaneContact, "contact", this.m_main_page);

      await import(`./pages/Infos`);
      this.registerPane(gClsPaneInfos, "info", this.m_main_page);

      await import(`./pages/LegalNotice`);
      this.registerPane(gClsPaneLegalNotice, "legal", this.m_main_page);

      await import(`./pages/Unsubscribe`);
      this.registerPane(gClsUnsubscribePage, "unsubscribe", this.m_main_page);

      await import(`./pages/QuickBuy`);
      this.registerPane(gClsQuickBuyPage, "quick_buy", this.m_main_page);

      await import(`./pages/PrintOrder`);
      this.registerPage(gClsPagePrintOrder, "print_order");

      await import(`./pages/ShowProgPDF`);
      this.registerPane(gClsShowProgPDFPage, "show_prog_pdf", this.m_main_page);
    } else if (gl_config.type == "chain") {
      await import(`./pages/chain/${gl_config.custom_pages.showmovie ?? 'default/ShowMovie'}`);
      this.registerPane(gClsChainShowMoviePage, "showmovie", this.m_main_page);
    }

    await import(`./pages/Debug`);
    this.registerPane(gClsDebugPage, "debug", this.m_main_page);

    // pour tout element de la navbar de config.js, faire des registerPane gClsPaneCustom
    // faire un "get_website_docs" avec tous les ID des pages contenu dans la navbar
    // passer dans le constructeur de la page le contenu récupéré de "get_website_docs"
    await import(`./pages/Custom`);
    if (gl_config.website.menus) {
      gl_config.website.menus.forEach(item => {
        if (!item.is_default_item) {
          if (item.link && item.link.type == "internal" && item.link.page_id) {
            // On fait du code pour gérer le cas où un menu créé par l'utilisateur pointerait vers une page par défaut.
            // Celle-ci étant register plus haut, il ne faut pas le register en tant que "PageCustom"
            // if (gl_config.website.menus.filter(l => (l.link && l.link.page_id == item.link.page_id) && l.is_default_item).length <= 0) {
            if (this.default_pages.filter(page => page.id == item.link.page_id).length <= 0) {
              this.registerPane(new PageCustom(), item.link.page_id, this.m_main_page);
            }
          }
        }
      });
    }

    if (this.stage == 'local') {
      // $("<link/>", { rel: "stylesheet", type: "text/css", href: "http://localhost:8888/themes/light_ms/theme.css" }).appendTo($("head"));
      // $("<link/>", { rel: "stylesheet", type: "text/css", href: "http://localhost:8888/themes/dark_ms/theme.css" }).appendTo($("head"));
    }

    let theme = gl_config.website && gl_config.website.style && gl_config.website.style.theme ? gl_config.website.style.theme : "light_ms";
    let url_theme = "https://static.monnaie-services.com/ticketing-themes/" + theme + "-" + gl_config.theme.vers + "/theme.css";
    $("<link/>", { rel: "stylesheet", type: "text/css", href: url_theme }).appendTo($("head"));

    this.registerHashFunction("logout", async () => {
      if (this.authToken()) {
        await gl_api.logout();
        console.log("logout");
        this.setAuthToken(false);
      }
      // this.setHash("#home", true);
      this.setHash("#login", true);
    });

    this.registerHashFunction("login", async (iQuery) => {
      console.log("registerHashFunction - login", iQuery)
      try {
        const res = await gl_api.loginWithToken(iQuery.db_stage, iQuery.token);
        gl_app.setAuthToken(res.auth_token);
      } catch (e) {
        await gl_api.showError(e);
      }
      gl_app.setHash("#", true);
    });

    this.registerHashFunction("renew_auth", async (iQuery) => {
      try {
        const res = await gl_api.refreshAuthToken(iQuery.group);
        gl_app.setAuthToken(res.auth_token);
        gl_app.setHash("#", true);
      } catch (e) {
        login_with_token;
        await gl_api.showError(e);
        gl_app.setHash("#", true);
      }
    });

    this.registerHashFunction("refresh", async () => {
      // window.location.reload();
    });

    this.registerHashFunction("ssr", async () => {
      if ($("body>div.ssr").length > 0) {
        $("body>div.ssr").show();
        setTimeout(() => {
          $("body>div#page_container").hide();
        }, 100);
      } else {
        alert("Pas de SSR");
      }
    });

    await this.init_app();

    this.onHashChanged();

    // Si site et pas groupe et on est sur mobile/tablette
    if (gl_config.type == "site" && is_on_mobile()) {
      // Si on est dans le navigateur web 
      if (!gl_mobile_app) {
        // Si le cinéma possède une app mobile
        if (gl_config.mobile_app) {
          this.showPromptMobileApp()
        } else {
          this.showPromptPWA();
        }
      }

      // Si on est dans l'app mobile
      // Un peu de modification CSS est nécessaire et ne peut être fait par media queries
      if (gl_mobile_app) {
        $(".main-section").css({
          "margin-bottom": 0
        });
        setTimeout(() => {
          $("#pane_container>.pane").css({
            "margin-bottom": 0
          });
        }, 500);
      }
    }

    if (!this.authToken()) {
      if (localStorage.getItem('persistent_token') && window.browser_id) {
        gl_api.loginWithPersistentToken().then((res) => {
          console.log('logged with persistent_token');
          gl_app.setAuthToken(res.auth_token);
        }).catch((err) => {
          console.log('loginWithPersistentToken failed', err);
        });
      }
    }

    // Désactivé (voir /serviceworker.js) 
    //
    //   if ('serviceWorker' in navigator) {
    //       navigator.serviceWorker.register('/serviceworker.js')
    //       .then((reg) => {
    //         // console.log(reg)
    //       })
    //       .catch((err) => {
    //         console.log(err)
    //       })
    //   };

    //   if ('serviceWorker' in navigator) {
    //     navigator.serviceWorker.getRegistrations().then(registrations => {
    //       if (registrations.length > 0) {
    //         console.log("Un Service Worker est enregistré (la PWA est peut-être installée).");
    //       } else {
    //         console.log("Aucun Service Worker n'est enregistré.");
    //       }
    //     });
    //   }
  }

  /*
    Navigation
   */

  defaultHash() {
    console.log("App - defaultHash")
    // On va regarder si le cinéma à paramétré une page par défaut depuis le BackOffice
    // var home_page_id = gl_config.website && gl_config.website.home_page_id ? gl_config.website.home_page_id : this.website_active ? "home" : "schedule";
    var home_page_id = gl_config.website && gl_config.website.home_page_id ? gl_config.website.home_page_id : "home";
    // return { hash: "home" };
    console.log(home_page_id)
    return { hash: home_page_id };
  }

  defaultPageTitle() {
    return gl_config.name;
  }

  seoActive() {
    // console.log("App - seoActive - stage :", this.stage)
    return this.stage == 'prod';
    // return this.stage == 'local';
  }

  seoKeywords() {
    return [
      _l('cinéma'),
      gl_config.name,
      gl_config.site.address.city,
    ].join(',');
  }


  onHashChanged() {
    const iQuery = MSApp.hashToQuery(window.location.hash);
    // console.log("onHashChanged", iQuery)

    // Si la page n'a pas été register, c'est qu'elle ne fait partie d'aucun menu (param depuis le BO)
    // Si on est en live_preview, on va faire un register pane à la volée pour pouvoir visualiser la page

    // J'ai retiré la condition du live_preview, car le clic d'un média créé depuis le BO peut pointer vers une page qui ne fait pas partie d'un menu, il faut donc la register à la volée
    // if((iQuery.live_preview && iQuery.hash) && !this.m_hash_pages[iQuery.hash]){
    if ((iQuery.hash) && !this.m_hash_pages[iQuery.hash]) {
      this.registerPane(new PageCustom(), iQuery.hash, this.m_main_page);
      // return;
    }
    //--------onHashChanged SEO
    // const seoConfig = seoConfigurations[iQuery.hash] || {
    //   title: "Page inconnue",
    //   description: "pas de description.",
    //   keywords: "erreur",
    // };
    // configSEO(seoConfig);

    // contenu statique - en test
    // if (iQuery.hash === "showmovie" && iQuery.id) {
    //   const movieDetails = {
    //     title: "Film Exemple",
    //     synopsis: "synopsis ",
    //     genre: "Action",
    //   };

    //   configSEO({
    //     title: `${movieDetails.title} - Mon Site`,
    //     description: movieDetails.synopsis,
    //     keywords: `${movieDetails.title}, ${movieDetails.genre}, cinéma, film`,
    //   });
    // }
    //-------- Fin onHashChanged SEO

    switch (iQuery.hash) {
      case "":
      case "home":
        $(".wrap_ios_bar").hide();
        this.PageIntervalRefresh = setInterval(() => {
          gClsHomePage.$fill_page()
        }, 1 * 600000) // 10 minutes
        break;
      default:
        $(".wrap_ios_bar").show();
        if (gl_app.PageIntervalRefresh) {
          // console.log("clear PageIntervalRefresh", gl_app.PageIntervalRefresh)
          clearInterval(gl_app.PageIntervalRefresh)
          gl_app.PageIntervalRefresh = null;
        }
        break;
    }

    super.onHashChanged();

    // ===== Affichage du pop-up de communication =====
    if (iQuery.hash == "login") {
      return;
    }
    this.gestion_communication();
  }

  authToken() {
    if (this.m_auth_token === undefined) {
      try {
        this.m_auth_token = JSON.parse(localStorage.getItem("auth_token"));
      } catch (e) {
        this.m_auth_token = false;
        console.warn("auth_token is broken", localStorage.getItem("auth_token"));
      }
    }

    if (this.m_auth_token && this.m_auth_token.expiration < Date.now()) {
      localStorage.removeItem("auth_token");
      this.m_auth_token = false;
      console.log("auth_token expired");
      this.setAuthToken(false);
    }

    if (!this.m_auth_token) {
      // console.log("auth_token is FALSE");
    }
    return this.m_auth_token;
  }

  authTokenId() {
    const token = this.authToken();
    return token ? token.id : false;
  }

  setAuthToken(iToken) {
    if (iToken) {
      this.m_auth_token = iToken;
      localStorage.setItem("auth_token", JSON.stringify(iToken));
      gl_api.setBearer(iToken.token);
    } else {
      localStorage.removeItem("auth_token");
      localStorage.removeItem("account_data");
      localStorage.removeItem("gift_buying");
      this.m_auth_token = false;
      gl_api.setBearer(false);
    }
  }

  update_user_auth_token(iUser) {
    // console.log("update_user_auth_token", iUser)
    if (iUser) {
      this.m_auth_token.user = iUser;
      localStorage.setItem("auth_token", JSON.stringify(this.m_auth_token));
    }
  }

  initThemeToggle() {
    const themesManager = new ToggleThemes();
    themesManager.$create();
  }

  async init_app() {
    const self = this;

    if (gl_config.type == "site") {
      switch (gl_config.software) {
        case "ems":
          // this.EMSConfiserie.init();
          if (gl_ems_config && gl_ems_config.data_cinema.confiserie && gl_ems_config.data_cinema.confiserie.active) {
            gl_api.get_conf().then((conf) => {
              gl_ems_config.data_cinema.confiserie.data = conf.conf;
              this.EMSConfiserie.init(gl_ems_config.data_cinema.confiserie);
            });
          }

          // Lancement de la mise à jour des jauges 
          if (gl_ems_config && gl_ems_config.data_cinema.show_availability) {
            self.maj_availability();
            setInterval(function () {
              self.maj_availability();
            }, 15000); // 15 secondes
          }
          break;
        case "ims":

          break;
        default:
          break;
      }
    }

    // ===== Récupération des communications paramétrées par l'exploitant depuis le BO =====
    gl_app.communication = [];
    try {
      let res_api_communication = await gl_api.list_docs({ "type": "communication" });
      let tab_communication_api = [];
      Object.values(res_api_communication).forEach(communication => {
        tab_communication_api.push("communication_" + communication.id);
      });

      if (tab_communication_api.length > 0) {
        res_api_communication = await gl_api.get_website_docs({ "docs": tab_communication_api });
        if (res_api_communication.docs) {
          gl_app.communication = Object.values(res_api_communication.docs ?? {});
        }
      }
    } catch (err) {
      console.log(err)
    }
  }

  arrondi(iParam) {
    var montant = iParam.montant;
    montant = Math.round(montant * 100) / 100;
    return montant.toFixed(2);
  }

  calc_fees_amount(iParam) {
    var frais_inclus = iParam.frais_inclus;
    var mode_frais = iParam.mode_frais;
    var total_frais = iParam.total_frais;
    var montant = iParam.montant;
    var qte = iParam.qte;
    var arrondi = false; // indique si la procédure doit arrondir le montant avant de la renvoyer, faux par défaut => l'arrondi se fera après l'addition des frais et du prix de base
    if (iParam.arrondi != undefined) {
      arrondi = iParam.arrondi;
    }

    var montant_frais = 0.00;

    if (frais_inclus == 0) {//frais exclu
      switch (mode_frais) {
        case 1://frais fixe en euros sur chaque billet
        case 4:
          if (parseFloat(montant) > 0) {
            montant_frais = parseFloat(total_frais) * qte;
          }
          break;
        case 2://frais en % par ligne de tarif
          montant_frais = parseFloat(((montant * total_frais) / 100));
          break;
        default:
          break;
      };
    };

    // ===== On transforme en chaine de caractère =====
    var s_montant_frais = montant_frais.toString();

    // ===== On récupère la taille de la chaine =====
    var size_s_montant_frais = s_montant_frais.length;

    // ===== Si il y a au moins 2 décimales =====
    if (size_s_montant_frais >= 5) {
      // ===== Si le dernier caractère est un 5 =====
      if ((s_montant_frais[size_s_montant_frais - 1]) == 5) {

        // ===== Récupération du dernier caractère ===== 
        var last_caract = parseInt(s_montant_frais[size_s_montant_frais - 1]);

        // ===== On ajoute 1 pour qu'il soit égal à 6 ===== 
        last_caract++;

        // ===== On reconstruit la chaîne du montant des frais en remplaçant le dernier caractère par la nouvelle valeur ===== 
        var s_montant_frais_temp = "";

        for (var i = 0; i < size_s_montant_frais; i++) {

          if (i == size_s_montant_frais - 1) {
            s_montant_frais_temp += last_caract;
          } else {
            s_montant_frais_temp += s_montant_frais[i];
          }

        }

        montant_frais = parseFloat(s_montant_frais_temp);
      }
    }

    if (arrondi) {
      montant_frais = Math.round(montant_frais * 100) / 100;
    }

    // console.log(montant_frais)
    return montant_frais;
  }

  ParseurNameSeats = function (val) {
    var name_seat = "";
    var pays = (gl_config.site.lang).toLowerCase();

    switch (pays) {
      case "fr":
        name_seat = val;
        break;
      case "es":
        // name_seat+="F";
        name_seat += ("ABCDEFGHIJKLMNOPQRSTUVWXYZ".indexOf(val[0])) + 1;
        // name_seat+="-B";
        name_seat += "-";
        name_seat += val.slice(1);
        break;
      default:
        name_seat = val;
        break;
    }

    return name_seat;
  }

  // Vérifie si le mot de passe respecte les règles de sécurité
  verifyPassword(iPassword) {
    if (iPassword.length < 8) {
      return _l("Le mot de passe doit contenir au moins 8 caractères");
    }
    if (! /\d/.test(iPassword)) {
      return _l("Le mot de passe doit contenir au moins un chiffre");
    }
    if (! /[a-z]/.test(iPassword)) {
      return _l("Le mot de passe doit contenir au moins une lettre minuscule");
    }
    if (! /[A-Z]/.test(iPassword)) {
      return _l("Le mot de passe doit contenir au moins une lettre majuscule");
    }
    return "";
  }

  async maj_availability() {
    if (gl_ems_config && gl_ems_config.data_cinema && gl_ems_config.data_cinema.show_availability) {
      await gl_api.get_availability().then((availability) => {
        gl_ems_config.availability = availability.availability;
        if (gl_ems_config.availability && gl_ems_config.availability.all) {
          const availability = gl_ems_config.availability.all;
          $.each(availability, (k, v) => {
            $(".wrap_availability_session_id_" + k).each((i, e) => {
              // console.log($(e).children(":first"))
              var $nb = $(e).children(":first");
              // Si la jauge a bougé
              if ($nb.length > 0 && parseInt($nb[0].textContent) != parseInt(v.std)) {
                if (v.std <= 0) {
                  $(e).empty();
                  $(e).addClass("text-danger")
                  $(e)[0].textContent = _l("Séance complète");
                } else {
                  $nb[0].textContent = v.std;
                }
              }
            });
          });
        }
      });
    }
  }

  async gestion_communication() {
    const iQuery = MSApp.hashToQuery(window.location.hash);
    // console.log("gestion_communication", iQuery)
    let now = moment();
    let communication_to_show = null;
    let communication_avoid = localStorage.getItem("communication_avoid") ? JSON.parse(localStorage.getItem("communication_avoid")) : [];
    let communication_showed = localStorage.getItem("communication_showed") ? JSON.parse(localStorage.getItem("communication_showed")) : [];
    let find = false;
    let severity = 0;
    if(!gl_app.communication){
      return;
    }
    gl_app.communication.forEach(communication => {
      // if(!communication.appearance || communication_to_show){
      // if (!communication.appearance || find) {
      if (!communication.appearance) {
        return;
      }

      switch (communication.appearance.type) {
        case "all":
          if(severity < 1){
            communication_to_show = communication;
            severity = 1;
          }
          break;
        case "all_session":
          if (iQuery.hash == "showsession" && severity < 2){
            communication_to_show = communication;
            severity = 2;
          }
          break;
        case "page":
          if (iQuery.hash == communication.appearance.page_id && severity < 2) {
            communication_to_show = communication;
            // find = true;
            severity = 2;
          }
          break;
        case "movie":
          if (iQuery.hash == "showmovie" && (iQuery.id && iQuery.id == communication.appearance.movie_id) && severity < 2) {
            communication_to_show = communication;
            // find = true;
            severity = 2;
          }
          break;
        case "session":
          if (iQuery.hash == "showsession" && (iQuery.id && iQuery.id == communication.appearance.session_id) && severity < 3) {
            communication_to_show = communication;
            // find = true;
            severity = 3;
          }
          break;
        case "superbillet":
          if (iQuery.hash == "showsuperbillet" && (iQuery.id && iQuery.id == communication.appearance.superbillet_id) && severity < 3) {
            communication_to_show = communication;
            // find = true;
            severity = 3;
          }
          break;
        default:
          break;
      }
    });

    // ===== Si un communication match, on va chercher ses médias =====
    if (communication_to_show) {
      // console.log("communication_to_show", communication_to_show)
      // console.log("communication_avoid", communication_avoid)

      const communication_options = communication_to_show.options;
      // On regarde si l'internaute à cliquer sur ne plus afficher
      if (communication_avoid && communication_avoid.indexOf(communication_to_show.id) >= 0) {
        return;
      }

      // On Regarde la redondance de la communication
      let com_showed = communication_showed.filter(com => com.id == communication_to_show.id)[0];
      if (communication_options && communication_options.time_redundancy > 0 && com_showed) {
        let time_com_showed = moment(com_showed.time, "YYYYMMDD HH:mm");
        const diff = now.diff(time_com_showed, "minutes")
        if (diff < communication_options.time_redundancy) {
          return
        }
      }

      // ===== Récupération de la config du média associé à la communication =====
      let tab_media_api = [];
      let media;
      communication_to_show.medias.forEach(media => {
        tab_media_api.push("media_" + media);
      });
      try {
        let res_api_media = await gl_api.get_website_docs({ "docs": tab_media_api });
        if (res_api_media.docs) {
          media = Object.values(res_api_media.docs)[0];
          media.media_url = media.media_url.replace("/120x", "/960x");
          media.media_url = media.media_url.replace("/320", "/1920");
          // Gestion des dates de validité d'affichage du media
          if (media.validity && media.validity.type == "date") {
            var from = media.validity.from;
            var to = media.validity.to;
            if (from > moment().format("YYYY-MM-DD") || to < moment().format("YYYY-MM-DD")) {
              return;
            }
          }
        }
      } catch (err) {
        console.log(err)
        return;
      }

      const res_api = await gl_api.getProg();
      this.m_prog = new Prog(res_api);
      this.prog_cine = res_api.schedule.events;
      this.superbillet_cine = res_api.schedule.super_billets;

      if (media.link && media.link.type == "file") {
        this.list_files = [];
        const res_api_file = await gl_api.get_website_docs({ "docs": ["file_" + media.link.file_id] });
        Object.values(res_api_file.docs).forEach(file => {
          // Si le fichier n'est pas déjà dans notre tableau global de fichiers, on le rajoute
          if (this.list_files.filter(f => f.id == file.id) <= 0) {
            this.list_files.push(file);
          }
        });
      }

      // ===== Si on arrive ici on peut afficher le pop up =====
      let buttons = [];
      if (communication_options && communication_options.see_no_longer_display) {
        buttons.push({
          class: "bold my-auto me-auto",
          title: _l("Ne plus afficher"),
          // preventClose : false,
          action: () => {
            communication_avoid.push(communication_to_show.id);
            localStorage.setItem("communication_avoid", JSON.stringify(communication_avoid))
          },
        });
      }
      buttons.push({
        class: "bold my-auto ms-auto",
        title: _l("Poursuivre sur le site"),
      });

      var $content = $("<div/>").addClass("d-flex");
        var $img = $("<img/>").addClass("w-100").attr({ "id": "img_communication" }).attr({ "src": media.media_url, "alt": communication_to_show.title ? _l(communication_to_show.title) : "Communication" }).appendTo($content);

      if (media.link && media.link.type != "none") {
        $img.addClass("pointer");

        $img.on("click", (e) => {
          e.preventDefault();
          // self.set_media_action(media)
          switch (media.link.type) {
            case "external_url":
              window.open(media.link.external_url, "_blank")
              break;
            case "file":
              if (this.list_files) {
                let file_data = this.list_files.filter(file => file.id == media.link.file_id)[0];
                if (file_data) {
                  const $link = $("<a/>").addClass("btn m-auto").attr({ "id": "btn_download_file", "href": file_data.media_url, "download": file_data.name }).appendTo($("body"));
                  $("#btn_download_file").get(0).click();
                  $link.remove();
                }
              }
              break;
            case "movie":
              window.location.href = "#showmovie?id=" + media.link.movie_id;
              break
            case "page":
              window.location.href = "#" + media.link.page_id;
              break;
            case "session":
              // Si le film est dans la prog, on redirige vers la page
              const movie_data = this.prog_cine.filter(event => event.id == media.link.movie_id)
              if (movie_data.length > 0) {
                // Si la séance est dans la prog, on redirige vers la page
                if (movie_data[0].sessions.filter(session => session.id == media.link.session_id).length > 0) {
                  window.location.href = "#showsession?id=" + media.link.session_id;
                }
              }
              break;
            case "superbillet":
              if (this.superbillet_cine.filter(sb => sb.id == media.link.superbillet_id).length > 0) {
                window.location.href = "#showsuperbillet?id=" + media.link.superbillet_id;
              }
              break;
            default:
              break;
          }
        });
      }

      this.modal_communication = new MSModal({
        buttons: buttons,
        has_close_box: false,
        html: $content,
        option: {
          dialog: {
            class: "modal-dialog-centered modal-xl modal-dialog-scrollable modal_communication"
          },
          title: {
            class: "w-100 h3 text-center"
          },
          type: "communication",
          data: communication_to_show
        },
        title: communication_to_show.title ? _l(communication_to_show.title) : "",
      })
      this.modal_communication.open();

      // On regarde dans le tableau des communications affichées si on trouve notre communication
      // Si oui, on met à jour l'entrée "time" (dernier date heure d'affichage) afin de gérer la redondance
      com_showed = communication_showed.filter(com => com.id == communication_to_show.id)[0];
      if (com_showed) {
        com_showed.time = moment().format("YYYYMMDDHHmmss");
      } else {
        communication_showed.push({
          id: communication_to_show.id,
          time: moment().format("YYYYMMDDHHmmss")
        });
      }

      localStorage.setItem("communication_showed", JSON.stringify(communication_showed));

      // On regarde si il y a un timeout pour faire disparaitre la communication automatiquement
      if (communication_options && communication_options.timeout_disappear > 0) {
        setTimeout(() => {
          this.modal_communication.close();
        }, communication_options.timeout_disappear * 1000);
      }
    }
  }

  showPromptPWA() {
    if (localStorage.getItem("has_pwa_installed")) {
      return;
    }
    var $block = $("<div/>").addClass("block_prompt_pwa").appendTo($(".main-section"));
    var $flex = $("<div/>").addClass("d-flex flex-column").appendTo($block);
    var $toggle_icon = $("<img/>").addClass("icon").attr({ "src": "https://static.monnaie-services.com/fontawesome/svgs/regular/xmark.svg", "alt": "icon" }).appendTo($flex);
    $("<p/>").addClass("text").text(_l("Installez cette application pour une meilleure expérience !")).appendTo($flex);
    var $btn = $("<button/>").addClass("btn btn_instruction p-0").attr({ "type": "button" }).text(_l("Comment installer")).appendTo($flex).on("click", () => {
      $(".block_prompt_pwa").remove();

      let buttons = [];
      buttons.push({
        class: "bg-danger text-white bold m-auto",
        title: _l("Fermer"),
      });
      buttons.push({
        class: "bg-success text-white bold m-auto",
        title: _l("Je confirme avoir installé l'app"),
        action: () => {
          localStorage.setItem("has_pwa_installed", true)
        }
      });

      var $content = $("<div/>").addClass("d-flex flex-column");
      $("<div/>").text(_l("Pour installer cette application : ")).appendTo($content);
      var $ul = $("<ul/>").addClass("list-group").appendTo($content);
      var $li = $("<li/>").addClass("list-group-item d-flex").appendTo($ul);
      $("<span/>").text(_l("Appuyez sur l'icône Partager se trouvant dans la barre d'adresse")).appendTo($li);
      $("<img/>").addClass("icon").attr({ "src": "https://static.monnaie-services.com/fontawesome/svgs/regular/arrow-up-from-square.svg", "alt": "icon" }).appendTo($li);
      var $li = $("<li/>").addClass("list-group-item d-flex").appendTo($ul);
      $("<span/>").text(_l("Sélectionnez 'Sur l'écran d'accueil'")).appendTo($li);
      $("<img/>").addClass("icon").attr({ "src": "https://static.monnaie-services.com/fontawesome/svgs/regular/square-plus.svg", "alt": "icon" }).appendTo($li);
      var $li = $("<li/>").addClass("list-group-item d-flex").appendTo($ul);
      $("<span/>").text(_l("Confirmez l'installation")).appendTo($li);

      new MSModal({
        buttons: buttons,
        has_close_box: false,
        html: $content,
        option: {
          dialog: {
            class: "modal-dialog-centered modal-xl modal-dialog-scrollable modal_instruction_pwa"
          },
          title: {
            class: "h2"
          }
        },
        title: _l("Installer l'application"),
      })
        .open();
    })

    $toggle_icon.on("click", (e) => {
      $(".block_prompt_pwa").remove();
      // if($(".block_prompt_pwa").hasClass("closed")){
      //   $(".block_prompt_pwa").removeClass("closed");
      //   $(e.currentTarget).removeClass("rotate");
      // }else{
      //   $(".block_prompt_pwa").addClass("closed");
      //   $(e.currentTarget).addClass("rotate");
      // }
    });
  }

  showPromptMobileApp() {
    console.log("showPromptMobileApp")
  }

  async fetch_path_svg(iFile) {
    // console.log("app.js - fetch_path_svg", iFile)
    try {
      const response = await fetch(iFile);
      if (!response.ok) throw new Error(`Erreur HTTP : ${response.status}`);

      const svgText = await response.text();
      return svgText;
    } catch (error) {
      console.error("Erreur lors de la récupération du SVG :", error);
      return null;
    }
  }

  async share_url(iUrl, iLabel) {
    console.log("share_url", iUrl, iLabel)

    if (gl_mobile_app) {
      // alert(_l("Appel à la fonction de partage de l'application mobile, "+ iUrl));
      gl_core.share_url(iUrl, iLabel);
    } else {
      navigator.clipboard.writeText(iUrl);
      MSToast.Success({
        "toast": {
          "id": "share_url"
        },
        "header": {
          "img": {
            "path": gl_config.logo_url
          }
        },
        "body": {
          "text": _l("URL copiée dans le presse-papier")
        }
      });
    }

  }

  // Modal pour noter et commenter les films 
  // Vient de la page ShowMovieDefault (lien reçu dans l'email)
  // Ou depuis l'espace client, liste des commandes
  async $rate_movie(iParam) {
    // console.log("$rate_movie", iParam)
    const event_id = iParam.event_id;
    const email = iParam.email;
    const key = iParam.key;
    var  stars = iParam.stars ? iParam.stars : 0;
    var comment = iParam.comment ? iParam.comment : "";
    var nickname = iParam.nickname ? iParam.nickname : null;

    if(!event_id || !email || !key) {
      return;
    };

    let buttons = [];
    buttons.push({
      class: "bold my-auto bg-danger",
      title: _l("Annuler")
    });
    buttons.push({
      class: "bold my-auto bg-success",
      title: _l("Valider"),
      action: async () => {
        comment = $("#rate_comment").val();
        nickname = $("#rate_nickname").val();
        try {
          let res = await gl_api.set_event_stars({
            key: key,
            event_id: event_id,
            email: email,
            stars: stars,
            comment: comment,
            nickname : nickname
          });
          Overlay.hide();
        } catch (err) {
          Overlay.hide();
          Swal.fire({
            icon: "warning",
            title: "Récupération des commandes",
            showCloseButton: true,
            text: _l(err.data ? err.data.message : err),
            heightAuto: false,
            scrollbarPadding: false,
            allowOutsideClick: false,
            customClass: {
              icon: "align-items-center",
            },
          }).then((result) => {
            // window.location.replace("#home");
          });
          return;
        }
        // Callback
        if(iParam.cb){
          iParam.cb();
        }else {
          Swal.fire({
            icon: "success",
            // title: "Récupération des commandes",
            showCloseButton: true,
            text: _l("Votre note a bien été prise en compte"),
            heightAuto: false,
            scrollbarPadding: false,
            allowOutsideClick: false,
            customClass: {
              icon: "align-items-center",
            },
          }).then((result) => {
            // window.location.replace("#home");
          });
          return;
        }
      }
    });

    var $content = $("<div/>").addClass("d-flex flex-column");
      var $box_nickname=$("<div/>").addClass("box_nickname").appendTo($content);
        var $row=$("<div/>").addClass("row").appendTo($box_nickname);
          var $col=$("<div/>").addClass("col-12 col-md-4").appendTo($row);
            var $form = $("<div/>").addClass("form-floating").appendTo($col);
              var $input = $("<input/>").addClass("form-control ").attr({type: "text",id: "rate_nickname",name: "rate_nickname",placeholder: _l("Votre pseudo"), "maxlength" : 50}).val(nickname).appendTo($form);
              var $label = $("<label/>").addClass("text-dark").attr({ for: "rate_nickname" }).text(_l("Votre pseudo")).appendTo($form);

      var $box=$("<div/>").addClass("box_stars d-flex flex-1 justify-content-center my-3 my-md-4").appendTo($content);
      for(var i=0;i<5;i++){
        if(stars && i<stars){
          var $stars=$("<div/>").addClass("svg_container icon icon_svg").attr({"id" : "star_"+i}).html(gl_app.list_icons_svg.filter(icon => icon.id == "solid_star")[0].svg_text).appendTo($box);
        }else{
          var $stars=$("<div/>").addClass("svg_container icon icon_svg").attr({"id" : "star_"+i}).html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_star")[0].svg_text).appendTo($box);
        }

        $stars.on("click", (e) => {
          var id = e.currentTarget.id.split("_")[1];
          for(var j=0;j<5;j++){
            if(j<=id){
              $("#star_"+j).html(gl_app.list_icons_svg.filter(icon => icon.id == "solid_star")[0].svg_text);
            }else{
              $("#star_"+j).html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_star")[0].svg_text);
            }
          }
          stars = parseInt(id) + 1;
        });
      }
      var $delete=$("<span/>").text(_l("Effacer")).addClass("my-auto ms-2 ms-md-5 pointer").appendTo($box).on("click", (e) => {
        stars = 0;
        for(var j=0;j<5;j++){
          $("#star_"+j).html(gl_app.list_icons_svg.filter(icon => icon.id == "regular_star")[0].svg_text);
        }
      });

      var $box_comment=$("<div/>").addClass("box_comment d-flex flex-1 justify-content-center").appendTo($content);
        var $textarea=$("<textarea/>").addClass("form-control").attr({ "id" : "rate_comment", "placeholder": _l("Laissez un commentaire (les commentaires doivent concernés le film uniquement et non le lieu de projection)"), "rows" : 5 }).val(comment).appendTo($box_comment);

    this.modal_rate_movie = new MSModal({
      buttons: buttons,
      has_close_box: false,
      html: $content,
      option: {
        dialog: {
          class: "modal-dialog-centered modal-xl modal-dialog-scrollable modal_rate_movie"
        },
        title: {
          class: "w-100 h3 text-center"
        },
        type: "rate_movie",
        data: iParam
      },
      title: _l("Noter le film"),
    })
    this.modal_rate_movie.open();
  }
}

